import React from 'react';
import { PropTypes } from 'prop-types';
import Button from '../Button';
var datepickerFilterBtnClass = 'datepicker__filterBtn';
var selectedSkinClasses = 'datepicker__filterBtn fontweight-500 datepicker__filterBtn-skin--selected';

var InfoPanelFilters = function InfoPanelFilters(props) {
  var filterClick = function filterClick(event, filter) {
    event.stopPropagation(); // prevent panel from closing on button click

    var selectedFilterButtonName = event.target.name;
    var date = filter.date,
        startDate = filter.startDate,
        endDate = filter.endDate;

    if (date) {
      return props.onClick({
        date: date,
        selectedFilterButtonName: selectedFilterButtonName
      });
    }

    return props.onClick({
      startDate: startDate,
      endDate: endDate,
      selectedFilterButtonName: selectedFilterButtonName
    });
  };

  var renderFilterButtons = function renderFilterButtons() {
    return props.filters.map(function (filter, i) {
      var buttonName = "filterBtn-".concat(i + 1);
      var className = props.selectedFilterButtonName === buttonName ? selectedSkinClasses : datepickerFilterBtnClass;
      return /*#__PURE__*/React.createElement("button", {
        className: className,
        onClick: function onClick(event) {
          filterClick(event, filter);
        },
        onKeyPress: function onKeyPress(event) {
          filterClick(event, filter);
        },
        key: buttonName,
        name: buttonName,
        type: "button"
      }, filter.name);
    });
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "datepicker__filterPanel overflowx-hidden overflowy-auto"
  }, renderFilterButtons()), /*#__PURE__*/React.createElement("div", {
    className: "datepicker__filters__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    kind: "secondary",
    size: "small",
    className: "datepicker__filters__buttons--cancel" // eslint-disable-next-line react/destructuring-assignment
    ,
    onClick: props.onCancel
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    kind: "primary",
    size: "small",
    className: "datepicker__filters__buttons--accept" // eslint-disable-next-line react/destructuring-assignment
    ,
    onClick: props.onAccept
  }, props.applyButtonText)));
};

InfoPanelFilters.propTypes = {
  filters: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  selectedFilterButtonName: PropTypes.string,
  applyButtonText: PropTypes.string
};
InfoPanelFilters.defaultProps = {
  selectedFilterButtonName: ''
};
InfoPanelFilters.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InfoPanelFilters",
  "props": {
    "selectedFilterButtonName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "filters": {
      "type": {
        "name": "array"
      },
      "required": true,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "onCancel": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "onAccept": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "applyButtonText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default InfoPanelFilters;